import { makeObservable, observable, action, computed } from 'mobx';

export class Clipboard {
	path;
	resType;
	multi = false;
	sessionKey;

	constructor(type = 'page') {
		this.sessionKey = `bl-clipboard-${type}`;
		makeObservable(this, {
			path: observable,
			resType: observable,
			multi: observable,
			update: action,
			pastable: computed,
			clear: action,
		});

		// load initial state, if any
		this.updateFromString(window.localStorage.getItem(this.sessionKey));

		//attach a storage listener so changes to the clipboard in other tabs get updated
		window.addEventListener('storage', event => {
			if (event.key === this.sessionKey) {
				this.updateFromString(event.newValue);
				Materialize.toast(
					'Updated clipboard from another tab.',
					4000,
					'clipboard-update rounded green'
				);
			}
		});
	}

	updateFromString(stored) {
		if (stored) {
			try {
				const { path, resType, multi } = JSON.parse(stored);
				this.path = path;
				this.resType = resType;
				this.multi = multi;
			} catch (e) {
				console.error('Error parsing stored clipboard value. Deleting');
				this.clear();
			}
		} else {
			this.clear();
		}
	}

	update({ path, resType, multi }) {
		this.path = path;
		this.resType = resType;
		this.multi = multi;

		window.localStorage.setItem(this.sessionKey, JSON.stringify({ path, resType, multi }));
	}

	get pastable() {
		return this.path && this.resType;
	}

	clear() {
		this.path = undefined;
		this.resType = undefined;
		this.multi = false;

		window.localStorage.removeItem(this.sessionKey);
	}
}
